<div class="border-circle" [ngStyle]="{'width': circleSize, 'height': circleSize}" [ngClass]="statusName">
    <i [ngClass]="statusName" *ngIf="statusName === 'blocked' || statusName === 'done'"></i>
</div>
